export default {
  draggedObject: {},
  highlightedOffers: [],
  isDraggingObject: false,
}
